import {SvgIcon} from "@mui/material";

export default function ValveIcon({sx}) {

    return (
        <SvgIcon sx={sx} viewBox="100 -8500 8000 11000">
            <path transform="scale(1, -1) translate(0, -880)" d={"M2650 8793 c-127 -21 -261 -93 -361 -193 -63 -62 -85 -94 -122 -171\n" +
                "-54 -112 -67 -169 -67 -292 0 -189 56 -323 190 -458 68 -68 102 -94 170 -127\n" +
                "148 -73 122 -72 1078 -72 l852 0 -1 -37 c0 -31 -48 -115 -273 -478 l-271 -440\n" +
                "-190 -7 c-215 -7 -282 -20 -390 -76 -136 -70 -260 -226 -300 -378 -19 -70 -21\n" +
                "-208 -4 -284 44 -204 210 -381 419 -445 32 -10 113 -20 195 -24 123 -7 146\n" +
                "-11 192 -34 169 -87 105 -214 -197 -386 -154 -87 -307 -189 -420 -279 -121\n" +
                "-96 -335 -310 -429 -429 l-73 -93 -429 0 -428 0 -3 278 c-3 276 -3 277 -30\n" +
                "334 -55 119 -164 192 -309 210 -44 5 -272 8 -512 6 -425 -4 -433 -4 -490 -27\n" +
                "-84 -33 -154 -94 -196 -171 l-36 -65 0 -2045 0 -2045 27 -55 c35 -71 107 -143\n" +
                "178 -178 l55 -27 525 0 525 0 59 29 c72 35 137 101 174 176 27 55 27 55 32\n" +
                "335 l5 280 427 3 c424 2 427 2 438 -19 6 -11 56 -75 109 -142 558 -693 1425\n" +
                "-1043 2362 -952 605 58 1139 301 1568 710 86 82 252 274 309 358 l33 47 412\n" +
                "-2 412 -3 5 -280 c5 -280 5 -280 32 -335 35 -71 107 -143 178 -178 l55 -27\n" +
                "525 0 525 0 55 27 c71 35 143 107 178 178 l27 55 0 2041 0 2041 -35 68 c-41\n" +
                "81 -108 141 -197 176 -57 23 -65 23 -490 27 -240 2 -468 -1 -512 -6 -145 -18\n" +
                "-254 -91 -309 -210 -27 -57 -27 -58 -30 -334 l-3 -278 -403 0 -404 0 -43 58\n" +
                "c-239 320 -580 608 -926 782 -139 69 -193 119 -212 195 -16 64 -14 80 15 114\n" +
                "33 40 99 59 244 71 63 5 140 17 170 26 189 56 332 190 402 374 28 76 32 96 32\n" +
                "195 1 185 -56 317 -190 445 -130 123 -233 158 -491 167 l-173 6 -230 419 -231\n" +
                "419 3 57 3 57 835 6 c601 4 847 8 877 17 278 79 474 321 490 607 15 263 -131\n" +
                "508 -372 626 -151 74 24 69 -2405 67 -1202 0 -2196 -3 -2210 -5z m4444 -344\n" +
                "c73 -27 148 -96 183 -167 24 -50 28 -69 28 -147 0 -78 -4 -97 -27 -140 -32\n" +
                "-60 -97 -124 -158 -156 l-45 -24 -925 -5 c-1035 -6 -962 0 -1015 -77 -25 -37\n" +
                "-25 -39 -25 -255 l0 -217 199 -363 200 -363 -182 -2 c-100 -2 -385 1 -634 5\n" +
                "l-452 7 229 372 c141 228 234 390 241 417 7 28 10 105 8 198 -4 131 -7 158\n" +
                "-24 187 -27 46 -64 72 -116 82 -24 4 -456 8 -960 9 -1017 0 -971 -3 -1064 68\n" +
                "-98 74 -148 203 -124 323 15 76 72 166 131 207 96 66 -89 61 2305 62 2167 0\n" +
                "2172 0 2227 -21z m-832 -2287 c61 -30 122 -100 144 -164 57 -173 -77 -357\n" +
                "-261 -358 -76 0 -214 -23 -286 -47 -173 -59 -284 -182 -311 -347 -9 -51 -7\n" +
                "-84 6 -162 36 -214 119 -314 354 -429 363 -178 652 -428 900 -776 88 -124 86\n" +
                "-123 360 -127 l222 -4 0 -1143 0 -1143 -242 -4 c-287 -4 -281 -2 -360 -118\n" +
                "-263 -382 -587 -653 -989 -823 -470 -200 -1043 -241 -1567 -112 -540 132 -991\n" +
                "445 -1318 914 -98 139 -99 140 -421 141 l-223 0 0 1144 0 1144 253 4 c216 3\n" +
                "257 6 284 21 18 9 59 55 94 105 207 292 471 523 829 727 186 105 309 209 382\n" +
                "319 142 218 82 469 -146 618 -93 60 -197 89 -356 97 -148 8 -184 19 -244 71\n" +
                "-58 51 -90 122 -89 200 0 131 77 232 203 266 35 10 347 12 1390 11 l1345 -2\n" +
                "47 -23z m-4814 -1585 c7 -8 12 -136 14 -357 3 -320 4 -347 22 -377 47 -78 99\n" +
                "-92 329 -93 l167 0 0 -1144 0 -1144 -198 -3 c-197 -4 -199 -4 -240 -31 -77\n" +
                "-51 -76 -49 -82 -443 l-5 -350 -450 -3 c-414 -2 -451 -1 -462 15 -10 13 -13\n" +
                "421 -13 1958 0 1740 2 1943 16 1963 l15 22 438 0 c342 0 441 -3 449 -13z\n" +
                "m7666 -9 c14 -20 16 -223 16 -1963 0 -1537 -3 -1945 -12 -1958 -12 -16 -49\n" +
                "-17 -463 -15 l-450 3 -5 345 c-5 324 -6 347 -26 384 -43 83 -84 95 -326 96\n" +
                "l-168 0 0 1145 0 1145 168 0 c229 1 281 15 328 93 18 30 19 57 22 377 2 221 7\n" +
                "349 14 357 8 10 107 13 449 13 l438 0 15 -22z\n"}/>
        </SvgIcon>
    )

}
